import { useEffect } from "react";
import StJosephHeroSection from "./components/HeroSection";
import StJosephStickyNav from "./components/StickyNav";
import StJosephProcessingTimeSection from "./components/ProcessingTimeSection";
import StJosephServicesSection from "./components/ServicesSection";
import StJosephLocalAreaSection from "./components/LocalAreaSection";
import StJosephTravelTimingSection from "./components/TravelTimingSection";
import StJosephDestinationsSection from "./components/DestinationsSection";
import StJosephTestimonialsSection from "./components/TestimonialsSection";
import StJosephAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import StJosephComparisonSection from "./components/ComparisonSection";
import StJosephMistakesSection from "./components/MistakesSection";
import StJosephHowItWorksSection from "./components/HowItWorksSection";
import StJosephFAQSection, { faqs } from "./components/FAQSection";
import StJosephHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import StJosephFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function StJosephPage() {
  useEffect(() => {
    document.title = "Emergency Passport St. Joseph, MO — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/st-joseph-mo/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in St. Joseph, MO — as fast as 24 hours. No appointment race in Kansas City. A+ BBB rated, registered State Dept. courier serving Northwest Missouri agriculture professionals, MWSU students, and Buchanan County families on the I-29 corridor.");
    setMeta("geo.placename", "St. Joseph, Missouri");
    setMeta("geo.region", "US-MO");
    setMeta("geo.position", "39.7675;-94.8467");
    setMeta("ICBM", "39.7675, -94.8467");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Missouri", item: "https://fastpassportcenter.com/missouri/" },
          { "@type": "ListItem", position: 3, name: "St. Joseph Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Fast Passport Center provides emergency and expedited passport services for St. Joseph and Northwest Missouri. As fast as 24 hours — no appointment race in Kansas City required.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "St. Joseph", containedInPlace: { "@type": "State", name: "Missouri" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-stjoseph";
    document.getElementById("structured-data-stjoseph")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-stjoseph")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <StJosephHeroSection />
      <StJosephStickyNav />
      <StJosephProcessingTimeSection />
      <StJosephServicesSection />
      <StJosephLocalAreaSection />
      <StJosephTravelTimingSection />
      <StJosephDestinationsSection />
      <StJosephTestimonialsSection />
      <StJosephAcceptanceFacilitiesSection />
      <StJosephComparisonSection />
      <StJosephMistakesSection />
      <StJosephHowItWorksSection />
      <StJosephFAQSection />
      <StJosephHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/st-joseph-mo" state="MO" />
      <StJosephFinalCTA />
    </div>
  );
}